import { Box, Flex, Text } from '@chakra-ui/react'

import PSkeleton from './Skeleton'
import VectorTitleLine from './Icons/VectorTitleLine'

const SectionTitle: React.FC<{
  children: React.ReactNode
  isLoading?: boolean
  isLineBg?: boolean
}> = ({
  children,
  isLoading = false,
  isLineBg = true,
}: {
  children: React.ReactNode
  isLoading?: boolean
  isLineBg?: boolean
}) => {
  return (
    <Flex justifyContent={'center'} alignItems={'center'} gap={[2, 6]}>
      {isLoading ? (
        <PSkeleton />
      ) : (
        <>
          {isLineBg && (
            <Box width={['20%', '140px']}>
              <VectorTitleLine width={'100%'} />
            </Box>
          )}
          <Text as={'div'} textAlign={'center'} textTransform={'uppercase'} fontSize={'2xl'}>
            {children}
          </Text>
          {isLineBg && (
            <Box width={['20%', '140px']} transform={'rotateY(180deg)'}>
              <VectorTitleLine width={'100%'} />
            </Box>
          )}
        </>
      )}
    </Flex>
  )
}

export default SectionTitle
